var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"nv-item-title"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }